import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledDesc,
  StyledHeader,
  StyledItem,
  StyledItems,
  StyledWrapper
} from './MGMTrade.styled';

const MGMTrade: React.FC = () => {
  const { t } = useI18n('member-get-member');

  const items = [
    {
      title: t('member-get-member.fredcoins.manfredite.title'),
      image: getPublicPath('/images/memberGetMember/reward5.svg'),
      fredcoins: t('member-get-member.fredcoins.manfredite.fredcoins-title'),
      desc: t('member-get-member.fredcoins.manfredite.desc')
    },
    {
      title: t('member-get-member.fredcoins.company.title'),
      image: getPublicPath('/images/memberGetMember/reward5.svg'),
      fredcoins: t('member-get-member.fredcoins.company.fredcoins-title'),
      desc: t('member-get-member.fredcoins.company.desc')
    }
  ];

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <Heading2 as="h3" editorial>
            {t('member-get-member.fredcoins.title')}
          </Heading2>
          <HtmlTrans
            ns="member-get-member"
            i18nKey="member-get-member.fredcoins.desc"
          />
        </StyledHeader>
        <StyledItems>
          {items.map((item, index) => (
            <StyledItem key={index}>
              <h4>{item.title}</h4>
              <img src={item.image} alt="" />
              <StyledDesc>
                <span>{item.fredcoins}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: item.desc
                  }}
                ></span>
              </StyledDesc>
            </StyledItem>
          ))}
        </StyledItems>
        <ButtonLink
          href="https://getmanfred.typeform.com/to/qQt6QXxM"
          target="_blank"
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('member-get-member.fredcoins.cta')}</span>
        </ButtonLink>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default MGMTrade;
